module.exports = __webpack_public_path__ + "img/ad1.3e952967.jpg";